import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/list-cross-icon.png'
import _imports_1 from '@/assets/img/dropdown-up-icon.png'
import _imports_2 from '@/assets/img/dropdown-icon.png'
import _imports_3 from '@/assets/img/Group.svg'


const _withScopeId = n => (_pushScopeId("data-v-f00fd2f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "select-card-ques" }
const _hoisted_3 = {
  id: "singleMultiDropdown",
  class: "dropdown"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "float-right button-arrow dropdown-button-arrow-img" }
const _hoisted_7 = {
  key: 0,
  class: "dropdown-button-arrow-img",
  src: _imports_1
}
const _hoisted_8 = {
  key: 1,
  class: "dropdown-button-arrow-img",
  src: _imports_2
}
const _hoisted_9 = { class: "dropdown-menu" }
const _hoisted_10 = {
  id: "search-btn",
  style: {"display":"flex"}
}
const _hoisted_11 = {
  key: 0,
  src: _imports_3,
  class: "search-icon"
}
const _hoisted_12 = ["placeholder"]
const _hoisted_13 = {
  id: "dropdown-scroll",
  class: "dropdown-scroll"
}
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "dropdown-checkbox-circle-division" }
const _hoisted_16 = ["checked"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  for: "checkbox-1",
  class: "checkbox-custom-label"
}, null, -1))
const _hoisted_18 = { class: "dropdown-item-text-division" }
const _hoisted_19 = { class: "selected-item-container" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: _ctx.inputDivId,
    class: "select-single-level comp-start"
  }, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.info.message), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("button", {
        id: "dropdownMultiMenuButton",
        class: _normalizeClass(["btn dropdown-button", !_ctx.showIcon ? 'dropdown-border' : 'dropdown-border-open']),
        type: "button",
        "data-toggle": "dropdown",
        "aria-haspopup": "true",
        "aria-expanded": "false",
        "data-display": "static",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onMenuClick($event)))
      }, [
        _createElementVNode("span", {
          style: _normalizeStyle(_ctx.dDWidth),
          class: _normalizeClass(["float-left select-placeholder", _ctx.selectedItems.length > 0 ? '' : 'select-placeholder-default'])
        }, [
          _createTextVNode(_toDisplayString(_ctx.selectPlaceholder) + " ", 1),
          (_ctx.selectedItems.length > 0 || null)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: "select-remove-all",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.onClickRemoveAll($event)))
              }, _hoisted_5))
            : _createCommentVNode("", true)
        ], 6),
        _createElementVNode("span", _hoisted_6, [
          (_ctx.showIcon || null)
            ? (_openBlock(), _createElementBlock("img", _hoisted_7))
            : (_openBlock(), _createElementBlock("img", _hoisted_8))
        ])
      ], 2),
      _withDirectives(_createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          (_ctx.enableSearch ? true : null)
            ? (_openBlock(), _createElementBlock("img", _hoisted_11))
            : _createCommentVNode("", true),
          (_ctx.enableSearch ? true : null)
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 1,
                ref: "search",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.search) = $event)),
                type: "text",
                placeholder: _ctx.searchPlaceholder,
                class: "search-dropdown"
              }, null, 8, _hoisted_12)), [
                [_vModelText, _ctx.search]
              ])
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("form", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, itemIndex) => {
            return (_openBlock(), _createElementBlock("a", {
              key: itemIndex,
              class: _normalizeClass(["dropdown-item", 
              _ctx.checkIsKeyValueExists('id', item.id, _ctx.selectedItems)
                ? 'selected-item'
                : ''
            ]),
              href: "javascript:void(0)",
              onClick: 
              (e) => {
                e.stopPropagation();
                _ctx.onSelectItem(item);
              }
            
            }, [
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("input", {
                  class: "checkbox-custom",
                  type: "checkbox",
                  checked: 
                  _ctx.checkIsKeyValueExists('id', item.id, _ctx.selectedItems)
                    ? true
                    : false
                
                }, null, 8, _hoisted_16),
                _hoisted_17
              ]),
              _createElementVNode("div", _hoisted_18, _toDisplayString(item.name), 1)
            ], 10, _hoisted_14))
          }), 128))
        ])
      ], 512), [
        [_vShow, _ctx.showIcon]
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_19, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedItems, (selItem, selItemIndex) => {
        return (_openBlock(), _createElementBlock("div", {
          key: selItemIndex,
          class: "selected-item-card",
          onClick: ($event: any) => (_ctx.onRemoveItem(selItemIndex))
        }, [
          _createTextVNode(_toDisplayString(selItem.name) + " ", 1),
          _hoisted_21
        ], 8, _hoisted_20))
      }), 128))
    ], 512), [
      [_vShow, !_ctx.showIcon]
    ])
  ], 8, _hoisted_1))
}